import {regionData, CodeToText} from 'element-china-area-data';

import areaJson from "../../../components/json/area";

export default {

    data() {
        return {
            cityMap: undefined
        }
    },

    mounted() {
        this.getMap(areaJson);
    },

    methods: {
        getMap(children) {
            if (!this.cityMap) {
                this.cityMap = {};
            }
            children.forEach(item => {
                this.cityMap[item.value] = item.label;
                if (item.children) {
                    this.getMap(item.children);
                }
            })
        },

        //字符串转数组
        strTransArray(mapStr) {
            return mapStr ? mapStr.split(",") : [];
        },

        isString(obj) {
            return toString.call(obj) === '[object String]';
        },

        isArray(val) {
            return toString.call(val) === '[object Array]';
        },

        //array转 地址数字
        arrayTransAddress(object) {
            if (!object) {
                throw new Error("object is not undefined");
            }
            if (this.isArray(object)) {
                return object ? object.join(',') : "";
            }
            if (this.isString(object)) {
                return object;
            }
        },


        //array 转 地址str
        arrayTransAddressStr(object) {
            if (!object) {
                throw new Error("object is not undefined");
            }

            if (this.isString(object)) {
                return object;
            }

            if (this.isArray(object)) {
                if (!object.length > 0) {
                   return "";
                }
                var regAddressStr = [];
                object.forEach(item => {
                    regAddressStr.push(this.cityMap[item]);
                })
                return regAddressStr.join(",");
            }



        },


    }
}



// WEBPACK FOOTER //
// ./src/configure/warp/support/mapUtils.js